import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldsetModule } from 'primeng/fieldset';
import { ChangeRequestItemComponent } from './change-request-item/change-request-item.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {RadioButtonModule} from 'primeng/radiobutton';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { PanelModule } from 'primeng/panel';
import { ChangeRequestHistoryModalComponent } from './change-request-history-modal/change-request-history-modal.component';
import { SharedModule } from '../shared/shared.module';
import { DialogModule } from 'primeng/dialog';
import { RejectChangeRequestModalComponent } from './reject-change-request-modal/reject-change-request-modal.component';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { MessageModule } from 'primeng/message';
import { ApprovePeriodicChangeRequestItemModalComponent } from './approve-periodic-change-request-item-modal/approve-periodic-change-request-item-modal.component';
import { RejectPeriodicChangeRequestItemModalComponent } from './reject-periodic-change-request-item-modal/reject-periodic-change-request-item-modal.component';
import { BptDateTimeModule } from 'bpt-ui-library/bpt-datetime';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { LabelComponent } from '../shared-components/label/label.component';

@NgModule({
  declarations: [
    ChangeRequestItemComponent,
    ChangeRequestHistoryModalComponent,
    RejectChangeRequestModalComponent,
    ApprovePeriodicChangeRequestItemModalComponent,
    RejectPeriodicChangeRequestItemModalComponent],
  imports: [
    CommonModule,
    FieldsetModule,
    InputTextareaModule,
    FormsModule,
    ReactiveFormsModule,
    RadioButtonModule,
    BptDropdownModule,
    ConfirmDialogModule,
    ToastModule,
    MessagesModule,
    BptTextInputModule,
    PanelModule,
    SharedModule,
    DialogModule,
    CheckboxModule,
    TooltipModule,
    MessageModule,
    BptDateTimeModule,
    EmptyResultsComponent,
    SpinnerComponent,
    LabelComponent
  ],
  exports:[
    ChangeRequestItemComponent,
    ChangeRequestHistoryModalComponent
  ]
})
export class ChangeRequestModule { }
